module.exports = __webpack_public_path__ + "static/img/4.e303a21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/4.png
// module id = tU/O
// module chunks = 0